/* OLVR ring builder: start loading a pick on touch (Oct 23, 2026).
   Loaded only on the ring builder, from sections/main-product.liquid
   (template suffix "builder"). Remove that script tag to undo.

   Every pick (shape, metal, hidden stone) makes Dawn ask Shopify for a fresh
   copy of the product section (assets/product-info.js renderProductInfo).
   That request only starts when the tap is released. This starts the same
   request the moment a finger lands on an option (or the mouse rests on it on
   desktop), then hands Dawn the answer when it asks, so the swap lands sooner.
   The request is built exactly as Dawn builds it; if anything differs, Dawn
   just fetches as it always did. */
(function () {
  if (window.__olvrPrefetch) return;
  window.__olvrPrefetch = true;

  var KEEP_MS = 20000;   /* KNOB: how long a prefetched answer stays usable */
  var HOVER_MS = 90;     /* KNOB: desktop, how long the mouse rests before prefetching */
  var MAX = 6;           /* most answers kept at once */

  var cache = {};        /* absolute url -> { p: Promise<Response>, at } */
  var nativeFetch = window.fetch.bind(window);

  function abs(u) { try { return new URL(u, location.href).href; } catch (e) { return null; } }

  function prune() {
    var keys = Object.keys(cache), now = Date.now();
    keys.forEach(function (k) { if (now - cache[k].at > KEEP_MS) delete cache[k]; });
    keys = Object.keys(cache);
    if (keys.length > MAX) keys.sort(function (a, b) { return cache[a].at - cache[b].at; })
      .slice(0, keys.length - MAX).forEach(function (k) { delete cache[k]; });
  }

  /* Dawn's own request for the same url gets the prefetched answer. */
  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url);
    var k = u && u.indexOf('section_id=') !== -1 && abs(u);
    var hit = k && cache[k];
    if (hit && Date.now() - hit.at < KEEP_MS && (!init || !init.method || init.method === 'GET')) {
      delete cache[k];
      var out = hit.p.then(function (r) { return r.clone(); }, function () { return nativeFetch(input, init); });
      /* Dawn cancels its request when a newer pick comes in. Honour that, or an
         older answer could land after a newer one. */
      var sig = init && init.signal;
      if (!sig) return out;
      if (sig.aborted) return Promise.reject(new DOMException('Aborted', 'AbortError'));
      return new Promise(function (resolve, reject) {
        sig.addEventListener('abort', function () { reject(new DOMException('Aborted', 'AbortError')); }, { once: true });
        out.then(resolve, reject);
      });
    }
    return nativeFetch(input, init);
  };

  /* The url Dawn would ask for if this option were picked:
     product url ? section_id=<section> & option_values=<checked ids, this one swapped in> */
  function urlFor(input) {
    var vs = input.closest('variant-selects');
    var info = input.closest('product-info');
    if (!vs || !info || input.checked || !input.dataset.optionValueId) return null;
    if (input.dataset.productUrl && input.dataset.productUrl !== info.dataset.url) return null; /* a different product, Dawn loads the whole page */
    var fieldset = input.closest('fieldset');
    var ids = Array.prototype.map.call(vs.querySelectorAll('select option[selected], fieldset input:checked'), function (el) {
      return (fieldset && el.closest('fieldset') === fieldset) ? input.dataset.optionValueId : el.dataset.optionValueId;
    });
    var section = info.dataset.originalSection || info.dataset.section;
    if (!section || !ids.length) return null;
    return info.dataset.url + '?section_id=' + section + '&option_values=' + ids.join(',');
  }

  function inputFrom(target) {
    var lab = target && target.closest && target.closest('variant-selects label');
    if (!lab) return null;
    return lab.control || (lab.htmlFor && document.getElementById(lab.htmlFor)) || lab.querySelector('input');
  }

  function prefetch(target) {
    var input = inputFrom(target);
    var u = input && input.type === 'radio' && urlFor(input);
    var k = u && abs(u);
    if (!k || cache[k]) return;
    prune();
    var p = nativeFetch(u, { credentials: 'same-origin' });
    cache[k] = { p: p, at: Date.now() };
    p.catch(function () { delete cache[k]; });
  }

  document.addEventListener('touchstart', function (e) { prefetch(e.target); }, { capture: true, passive: true });
  document.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') prefetch(e.target); }, true);

  var hoverTimer = null;
  document.addEventListener('mouseover', function (e) {
    clearTimeout(hoverTimer);
    var t = e.target;
    if (!t || !t.closest || !t.closest('variant-selects label')) return;
    hoverTimer = setTimeout(function () { prefetch(t); }, HOVER_MS);
  }, true);
})();
